import { GET_CLIENTS, GET_CLIENTS_SUCCESS, GET_CLIENTS_FAIL,GET_CLIENT_LOADING,
    CLIENT_STATUS, CLIENT_STATUS_SUCCESS, CLIENT_STATUS_FAIL} from "./actionTypes";

export const getClients=()=>({
    type: GET_CLIENTS,
})
export const getClientsSuccess= clients =>({
    type: GET_CLIENTS_SUCCESS,
    payload: clients
})
export const getClientsLoading= (loading) =>( 
    {
    type: GET_CLIENT_LOADING,
    payload: loading
})
export const getClientsFail= error =>({
    type: GET_CLIENTS_FAIL,
    payload: error
})